module.exports = "/static/assets/12533519dd0802f603e692afc907ef52.png";